// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0a1e677a","239":"a15ef0ae","488":"21ac3377","732":"1869d6de"}[chunkId] + ".chunk.js";
};